<template>
    <div class="">
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="bg-theme-green px-4 py-2 text-white">
          <div class="flex justify-between items-center">
            <div class="font-bold tracking-wider leading-tight text-2xl mt-0 ">
              <span class="capitalize">{{ item.integrationProvider ? item.integrationProvider : 'Add New Access Key'}}</span> - {{ visibleToken(item.integrationValue) }}
            </div>

            <div class="flex items-center justify-between">
                
              <button @click="deleteRecord()" class="cursor-pointer rounded-md bg-white text-theme-red py-2 px-4  hover:bg-theme-darkgreen hover:text-white mr-3">DELETE</button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-2  hover:opacity-70">CLOSE</span>
                <!-- <mdicon @click.prevent="clearComponent" size="32" class="close-icon flex justify-end cursor-pointer hover:opacity-60 mb-2 " name="close" /> -->
                <!-- <div class="flex justify-between"> -->
                    <!-- <a v-if="cloverVerifyUrl" class="is-flex hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold" target="_blank" @click.prevent="openUrlWindow()" href="#">
                    Verify
                  </a> -->
                    <!-- <button v-if="cloverVerifyUrl"  @click.prevent="openUrlWindow()" class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold">VERIFY</button> -->
                    <!-- <mdicon @click="deleteRecord()" name="trash-can-outline" class="hover:bg-theme-red hover:text-white del-icon border-0 rounded-md cursor-pointer text-theme-red bg-white ml-2 pt-2 py-1 px-1" />
                </div> -->

            </div>


          </div>
        </div>
      

        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
          <div class="flex flex-col gap-3 items-start mb-3">
          
              <div class="w-full">
                <div :class="'input-wrapper'">
                  <label class="text-xs mb-1">Name:</label>
                  <p class="capitalize text-xs">{{ item.integrationProvider }}</p>
                </div>
              </div>

              <div class="w-full">
                <div :class="'input-wrapper'">
                  <label class="text-xs mb-1">Token:</label>
                  <p class="text-xs">{{ visibleToken(item.integrationValue) }}</p>
                </div>
              </div>
  
              <!-- <div class="w-full xl:w-1/2">
                <div :class="'input-wrapper ' + (form.merchantId.error_type)">
                  <label class="text-xs mb-1">Merchant ID:</label>
                  <input placeholder="Merchant ID (Optional)"  @keyup="validateFields(['merchantId'])" v-model="form.merchantId.value" class="block rounded bg-gray-black w-full" type="text" />
                  <p class="field-error label-text mt-1" v-if="form.merchantId.error_message" v-text="form.merchantId.error_message"></p>
                </div>
              </div> -->
            </div>
  
            <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
  
              <div class="w-full xl:w-1/2 mt-3" v-if="form.integrationProvider.value == 'clover'">
                  <!-- <a v-if="cloverVerifyUrl" class="is-flex hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase font-semibold" target="_blank" @click.prevent="openUrlWindow()" href="#">
                    Verify
                  </a> -->
              </div>
          
  
            </div>
          </div>
      </div>
    </div>

    <ReturnConfirmModal v-if="deleteObj.modal" :obj="deleteObj.obj" :closeClick="closeDeleteModal" :actionClick="deleteNow" :heading="'You Are About To Delete ' + deleteObj.obj.integrationProvider " />
    </template>
    
    <script lang="ts">
    import {
        defineComponent,
        ref
    } from "vue"
    import {
        mapGetters,
        mapActions,
        mapMutations
    } from "vuex";
    import LocationPosStationApis from "@/controllers/LocationPosStationApis";
    import LocationIntegrationApis from "@/controllers/LocationIntegrationApis";
    import {
        useSnackbar
    } from "vue3-snackbar";
    import Helpers from '@/helpers';
    import ReturnConfirmModal from "@/components/general/dialog/ReturnConfirmModal.vue";
    import LocationPaymentProcessorApis from "@/controllers/LocationPaymentProcessorApis";
    import Env from '@/env';
    
    export default defineComponent({
        name: "LocationPosAdd",
        components: {
            ReturnConfirmModal
        },
        setup() {
            const snackbar = useSnackbar();
            const deleteObj = ref({
                modal: false,
                obj: {},
            });
            const cloverAccess = < any > ref({
                verified: false,
                accessCode: '',
            });
            const form:any = ref({
                integrationProvider: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
                },
                integrationKey: 'access_token',
                sort: 1,
                merchantId: {
                    value: '', //E7JT323858QX1
                    error_type: '',
                    error_message: '',
                    validations: [],
                },
            
                active: false,
            });
            return {
                form,
                snackbar,
                deleteObj,
                cloverAccess
            };
        },
        props: {
            clearComponent: {
                type: Function,
                required: true,
            },
            item: {
                type: Object,
                required: true,
            },
        },
    
        watch: {
    
           
        },
    
        computed: {
       
        },
    
        mounted() {
        
        },
    
        methods: {
    
            /**
             * Delete location tax
             */
            async deleteRecord() {
                this.deleteObj = {
                    modal: true,
                    obj: this.item,
                };
            },
    
            /**
             * Close delete modal
             */
            closeDeleteModal() {
                this.deleteObj = {
                    modal: false,
                    obj: {},
                };
            },
    
            /**
             * Delete Pos
             */
            async deleteNow(obj) {
                this.va_spinner(true);
                let res = await LocationIntegrationApis.deleteClover();
                this.va_spinner(false);
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                if (res.status == 200) {
                    this.emitter.emit("refresh-location-access-token-list", true);
                    this.clearComponent();
                }
            },


            /**
             * Accesstoken display
             */

            visibleToken(token) {
                if(!token)
                return;
                return `${String(token).slice(0, 4)}*****${String(token).slice(-4)}`

            },
    
            ...mapActions({
                va_spinner: 'spinner/setSpinner',
            })
        },
    });
    </script>
    